module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0017.jpg?v=4275d12a";